import { render, staticRenderFns } from "./track-details.vue?vue&type=template&id=282c2725"
import script from "./track-details.vue?vue&type=script&lang=js"
export * from "./track-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports